import "./backdropLoader.css";
import { useSelector } from "react-redux";
import { gifs } from "../../utils/globalImages";

function BackdropLoader({ show = false }) {
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);

  if (!show) return null;

  return (
    <div
      className={`backdrop ${
        isDarkMode ? "background-dark" : "background-light"
      }`}
    >
      <div className="loader">
        <img src={gifs.backdropLoader} alt="loader" />
      </div>
    </div>
  );
}

export default BackdropLoader;
